import type { DocumentScanOpenParams } from "../../../../lib/analytics/types";
import type { ScanbotResult } from "./types";

/**
 * This function is not implemented on web. It is only implemented on native.
 */
export const openScanbot = (
  _params: DocumentScanOpenParams,
): Promise<ScanbotResult> => {
  throw new Error("Not implemented");
};
